const sk = {
  // ============================================================
  // COMMON — Zdieľané v celej aplikácii
  // ============================================================
  common: {
    loading: 'Načítava sa...',
    error: 'Chyba',
    save: 'Uložiť',
    cancel: 'Zrušiť',
    delete: 'Vymazať',
    edit: 'Upraviť',
    create: 'Vytvoriť',
    add: 'Pridať',
    remove: 'Odstrániť',
    close: 'Zavrieť',
    confirm: 'Potvrdiť',
    apply: 'Použiť',
    reset: 'Obnoviť',
    search: 'Hľadať',
    filter: 'Filter',
    clear: 'Vyčistiť',
    back: 'Späť',
    next: 'Ďalej',
    previous: 'Predchádzajúci',
    submit: 'Odoslať',
    update: 'Aktualizovať',
    refresh: 'Obnoviť',
    export: 'Exportovať',
    import: 'Importovať',
    download: 'Stiahnuť',
    upload: 'Nahrať',
    print: 'Tlačiť',
    copy: 'Kopírovať',
    yes: 'Áno',
    no: 'Nie',
    ok: 'OK',
    done: 'Hotovo',
    select: 'Vybrať',
    selectAll: 'Vybrať všetko',
    deselectAll: 'Zrušiť výber',
    noResults: 'Žiadne výsledky',
    noData: 'Žiadne dostupné údaje',
    required: 'Povinné',
    optional: 'Voliteľné',
    actions: 'Akcie',
    details: 'Podrobnosti',
    overview: 'Prehľad',
    summary: 'Súhrn',
    total: 'Celkom',
    all: 'Všetky',
    none: 'Žiadny',
    name: 'Názov',
    type: 'Typ',
    status: 'Stav',
    date: 'Dátum',
    time: 'Čas',
    description: 'Popis',
    notes: 'Poznámky',
    comments: 'Komentáre',
    category: 'Kategória',
    priority: 'Priorita',
    nation: 'Národ',
    country: 'Krajina',
    email: 'E-mail',
    phone: 'Telefón',
    address: 'Adresa',
    location: 'Poloha',
    coordinates: 'Súradnice',
    latitude: 'Zemepisná šírka',
    longitude: 'Zemepisná dĺžka',
    from: 'Od',
    to: 'Do',
    createdAt: 'Vytvorené',
    updatedAt: 'Aktualizované',
    createdBy: 'Vytvoril',
    modifiedBy: 'Upravil',
    active: 'Aktívny',
    inactive: 'Neaktívny',
    enabled: 'Povolené',
    disabled: 'Zakázané',
    showing: 'Zobrazuje sa',
    of: 'z',
    page: 'Strana',
    perPage: 'na stranu',
    rows: 'riadky',
    items: 'položky',
    results: 'výsledky',
    sortBy: 'Zoradiť podľa',
    ascending: 'Vzostupne',
    descending: 'Zostupne',
    viewAll: 'Zobraziť všetko',
    viewDetails: 'Zobraziť podrobnosti',
    goBack: 'Vrátiť sa',
    learnMore: 'Zistiť viac',
    seeMore: 'Zobraziť viac',
    showMore: 'Zobraziť viac',
    showLess: 'Zobraziť menej',
    expandAll: 'Rozbaliť všetko',
    collapseAll: 'Zbaliť všetko',
    copied: 'Skopírované!',
    saved: 'Uložené!',
    deleted: 'Vymazané!',
    updated: 'Aktualizované!',
    created: 'Vytvorené!',
    success: 'Úspech',
    warning: 'Upozornenie',
    info: 'Informácia',
    danger: 'Nebezpečenstvo',
    unknown: 'Neznámy',
    notAvailable: 'Nedostupné',
    never: 'Nikdy',
    today: 'Dnes',
    yesterday: 'Včera',
    tomorrow: 'Zajtra',
    now: 'Teraz',
    ago: 'pred',
    justNow: 'práve teraz',
    minutesAgo: 'pred {{count}} min',
    hoursAgo: 'pred {{count}} hod',
    daysAgo: 'pred {{count}} dňami',
    monthsAgo: 'pred {{count}} mes',
    id: 'ID',
    version: 'Verzia',
    language: 'Jazyk',
    theme: 'Téma',
    darkMode: 'Tmavý režim',
    lightMode: 'Svetlý režim',
    failedToLoad: 'Nepodarilo sa načítať údaje',
    failedToSave: 'Nepodarilo sa uložiť',
    failedToDelete: 'Nepodarilo sa vymazať',
    failedToUpdate: 'Nepodarilo sa aktualizovať',
    confirmDelete: 'Naozaj chcete vymazať túto položku?',
    confirmAction: 'Ste si istý?',
    unsavedChanges: 'Máte neuložené zmeny. Naozaj chcete odísť?',
    pageNotFound: '404 - Stránka nenájdená',
    pageNotFoundDesc: 'Stránka, ktorú hľadáte, neexistuje.',
    backToDashboard: 'Späť na hlavný panel',
    characters: 'znaky',
    maxCharacters: 'Maximálne {{max}} znakov',
    remaining: '{{count}} zostáva',
    selected: '{{count}} vybraných',
    of_total: '{{count}} z {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Hlavička, bočný panel, menu
  // ============================================================
  nav: {
    dashboard: 'Hlavný panel',
    requests: 'Žiadosti',
    transports: 'Prepravy',
    myPatients: 'Moji pacienti',
    statistics: 'Štatistiky',
    flow: 'Tok',
    resources: 'Resources',
    exercise: 'Cvičenie',
    administration: 'Administrácia',
    map: 'Mapa',
    info: 'Informácie',
    users: 'Používatelia',
    assets: 'Prostriedky',
    hubs: 'Uzly',
    treatmentFacilities: 'Liečebné zariadenia',
    patientImport: 'Import pacientov',
    assetTemplates: 'Šablóny prostriedkov',
    dayTemplates: 'Denné šablóny',
    announcementTicker: 'Oznamovací panel',
    exerciseStatistics: 'Štatistiky cvičenia',
    settings: 'Nastavenia',
    auditLog: 'Protokol auditu',
    exerciseControl: 'Riadenie cvičenia',
    dataSync: 'Synchronizácia údajov',
    documentation: 'Dokumentácia',
    support: 'Podpora',
    about: 'O systéme',
    assetContracts: 'Asset Contracts',
    notifications: 'Oznámenia',
    schedules: 'Harmonogramy',
    capacityPlanning: 'Plánovanie kapacít',
    transportPlanning: 'Plánovanie prepravy',
    transportBooking: 'Rezervácia prepravy',
    flowDiagram: 'Diagram toku',
    changePassword: 'Zmeniť heslo',
    missions: 'Misie',
    startPoints: 'Východiskové body',
    hospital: 'Nemocnica',
  },

  // ============================================================
  // AUTH — Prihlásenie, heslo, relácia
  // ============================================================
  auth: {
    login: 'Prihlásiť sa',
    logout: 'Odhlásiť sa',
    logoutNow: 'Odhlásiť sa teraz',
    loggingIn: 'Prihlasovanie...',
    loginFailed: 'Prihlásenie zlyhalo',
    email: 'E-mail',
    password: 'Heslo',
    username: 'Používateľské meno',
    enterEmail: 'Zadajte svoju e-mailovú adresu',
    enterPassword: 'Zadajte svoje heslo',
    enterUsername: 'Zadajte svoje používateľské meno',
    forgotPassword: 'Zabudli ste heslo?',
    forgotPasswordTitle: 'Zabudnuté heslo',
    forgotPasswordDesc: 'Zadajte svoje používateľské meno a e-mailovú adresu. Ak sa oba údaje zhodujú, administrátori budú upozornení na obnovenie vášho hesla.',
    requestPasswordReset: 'Požiadať o obnovenie hesla',
    sending: 'Odosiela sa...',
    backToLogin: 'Späť na prihlásenie',
    pleaseWait: 'Prosím počkajte pred ďalším pokusom.',
    requestFailed: 'Požiadavka zlyhala',
    credentialsMatch: 'Ak sa prihlasovacie údaje zhodujú, administrátori boli upozornení.',
    forAccess: 'Pre prístup kontaktujte svojho správcu systému.',
    changePassword: 'Zmeniť heslo',
    currentPassword: 'Aktuálne heslo',
    newPassword: 'Nové heslo',
    confirmPassword: 'Potvrdiť heslo',
    passwordChanged: 'Heslo bolo úspešne zmenené',
    passwordMismatch: 'Heslá sa nezhodujú',
    passwordTooShort: 'Heslo musí mať aspoň 8 znakov',
    changingPassword: 'Mení sa...',
    mustChangePassword: 'Pred pokračovaním musíte zmeniť svoje heslo.',
    sessionExpiring: 'Relácia vyprší',
    sessionExpireText: 'Vaša relácia vyprší o <strong>{{time}}</strong>. Prosím uložte svoju prácu a znova sa prihláste.',
    dismiss: 'Zavrieť',
    switchNation: 'Prepnúť národ',
    returnTo: 'Vrátiť sa k {{nation}}',
    viewingAs: 'Zobrazujete sa ako',
    loggedInAs: 'prihlásený ako {{nation}}',
    trainingMode: 'LEN PRE ÚČELY VÝCVIKU',
    dedication: 'Vytvorené s láskou a oddanosťou profesii',
  },

  // ============================================================
  // ROLES — Používateľské role a označenia
  // ============================================================
  roles: {
    admin: 'Správca systému',
    excon: 'Riaditeľ cvičenia',
    eu: 'Koordinátor EÚ',
    planner: 'Plánovač',
    hub: 'Správca uzla',
    nation: 'Národ',
    readOnly: 'Len na čítanie',
    systemAdmin: 'Správca systému',
    transportPlanner: 'Plánovač prepravy',
    systemRoles: 'Systémové role',
  },

  // ============================================================
  // STATUS — Stavy žiadostí, ponúk, misií
  // ============================================================
  status: {
    draft: 'Koncept',
    underReview: 'V kontrole',
    published: 'Publikované',
    underSelection: 'Vo výbere',
    accepted: 'Prijaté',
    planned: 'Plánované',
    inTransit: 'Na ceste',
    completed: 'Dokončené',
    closed: 'Uzavreté',
    withdrawn: 'Stiahnuté',
    pending: 'Čakajúce',
    rejected: 'Zamietnuté',
    cancelled: 'Zrušené',
    active: 'Aktívne',
    inactive: 'Neaktívne',
    review: 'Kontrola',
    selection: 'Výber',
    transit: 'Preprava',
  },

  // ============================================================
  // CATEGORIES — Kategórie žiadostí
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personál',
    material: 'Materiál',
    equipment: 'Vybavenie',
    other: 'Iné',
    news: 'Správy',
  },

  // ============================================================
  // URGENCY — Úrovne naliehavosti
  // ============================================================
  urgency: {
    routine: 'Bežná',
    priority: 'Prioritná',
    urgent: 'Naliehavá',
    immediate: 'Okamžitá',
  },

  // ============================================================
  // ASSETS — Typy prepravných prostriedkov
  // ============================================================
  assetTypes: {
    train: 'Vlak',
    ship: 'Loď',
    aircraft: 'Lietadlo',
    bus: 'Autobus',
    ambulance: 'Sanitka',
    drone: 'Dron',
    helicopter: 'Vrtuľník',
    ferry: 'Trajekt',
    other: 'Iné',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Hlavný panel',
    goodMorning: 'Dobré ráno',
    goodAfternoon: 'Dobré popoludnie',
    goodEvening: 'Dobrý večer',
    lastLogin: 'Posledné prihlásenie',
    infrastructure: 'Infraštruktúra',
    transportAssets: 'Prepravné prostriedky',
    treatmentFacilities: 'Liečebné zariadenia',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Štatistiky žiadostí',
    viewAllRequests: 'Zobraziť všetky žiadosti',
    availableAssets: 'Dostupné prostriedky',
    seated: 'Sediaci',
    lying: 'Ležiaci',
    intensive: 'Intenzívny',
    notifications: 'Oznámenia',
    markAllRead: 'Označiť všetky ako prečítané',
    noNotifications: 'Zatiaľ žiadne oznámenia',
    notifiedWhenActivity: 'Budete upozornení, keď nastane nová aktivita',
    viewDetailsBtn: 'Zobraziť podrobnosti',
    nationUsers: 'Používatelia národa',
    user: 'Používateľ',
    roles: 'Role',
    noUsersFound: 'Žiadni používatelia nenájdení',
    participatingNations: 'Zúčastnené národy',
    exerciseDisclaimer: 'Tento systém je určený len na cvičné účely. Zadávajte výhradne simulované cvičné údaje. Pracovné postupy sú prispôsobené scenáru cvičenia a môžu sa líšiť od reálnych postupov. Pravidlá IT bezpečnosti a ochrany údajov zostávajú plne platné.',
    notConfigured: 'Nenakonfigurované',
    requestCount: '{{count}} žiadosť(í)',
    clickToView: 'Kliknutím zobrazíte',
    systemAdministration: 'Správa systému',
    exerciseControlTitle: 'Riadenie cvičenia',
    euCoordination: 'Koordinácia EÚ',
    transportPlanningTitle: 'Plánovanie prepravy',
    hubManagement: 'Správa uzlov',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Nová žiadosť',
    myDrafts: 'Moje koncepty',
    pendingReview: 'Čakajúce na kontrolu',
    activeTransports: 'Aktívne prepravy',
    myPatients: 'Moji pacienti',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Žiadosti',
    newRequest: 'Nová žiadosť',
    createRequest: 'Vytvoriť žiadosť',
    editRequest: 'Upraviť žiadosť',
    requestDetail: 'Detail žiadosti',
    requestId: 'ID žiadosti',
    fromNation: 'Od národa',
    toNation: 'Pre národ',
    requestingNation: 'Žiadajúci národ',
    receivingNation: 'Prijímajúci národ',
    category: 'Kategória',
    urgency: 'Naliehavosť',
    status: 'Stav',
    patients: 'Pacienti',
    patientCount: 'Počet pacientov',
    offers: 'Ponuky',
    offerCount: 'Počet ponúk',
    created: 'Vytvorené',
    updated: 'Aktualizované',
    submittedBy: 'Odoslal',
    reviewedBy: 'Skontroloval',
    description: 'Popis',
    medicalDetails: 'Zdravotné údaje',
    transportDetails: 'Prepravné údaje',
    additionalInfo: 'Doplňujúce informácie',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Miesto odchodu',
    arrivalPoint: 'Miesto príchodu',
    estimatedDeparture: 'Odhadovaný odchod',
    estimatedArrival: 'Odhadovaný príchod',
    submitForReview: 'Odoslať na kontrolu',
    publish: 'Publikovať',
    startSelection: 'Začať výber',
    acceptOffer: 'Prijať ponuku',
    markInTransit: 'Označiť ako na ceste',
    markCompleted: 'Označiť ako dokončené',
    closeRequest: 'Uzavrieť žiadosť',
    withdrawRequest: 'Stiahnuť žiadosť',
    withdraw: 'Stiahnuť',
    revertToDraft: 'Vrátiť na koncept',
    deleteRequest: 'Vymazať žiadosť',
    duplicateRequest: 'Duplikovať žiadosť',
    createFollowUp: 'Vytvoriť konsolidovanú žiadosť',
    followUpRequest: 'Konsolidovaná žiadosť',
    parentRequest: 'Pôvodná žiadosť',
    childRequests: 'Konsolidované žiadosti',
    noRequests: 'Žiadne žiadosti nenájdené',
    noOffers: 'Zatiaľ žiadne ponuky',
    addPatient: 'Pridať pacienta',
    removePatient: 'Odstrániť pacienta',
    patientDetails: 'Údaje o pacientovi',
    contactPerson: 'Kontaktná osoba',
    contactPhone: 'Kontaktný telefón',
    contactEmail: 'Kontaktný e-mail',
    specialRequirements: 'Špeciálne požiadavky',
    medicalEquipment: 'Zdravotnícke vybavenie',
    accompaniment: 'Doprovod',
    timeline: 'Časová os',
    history: 'História',
    addComment: 'Pridať komentár',
    writeComment: 'Napíšte komentár...',
    postComment: 'Odoslať komentár',
    posting: 'Odosiela sa...',
    noComments: 'Zatiaľ žiadne komentáre',
    coverageBar: 'Pokrytie',
    covered: 'pokryté',
    uncovered: 'nepokryté',
    filterByStatus: 'Filtrovať podľa stavu',
    filterByCategory: 'Filtrovať podľa kategórie',
    filterByNation: 'Filtrovať podľa národa',
    searchRequests: 'Hľadať žiadosti...',
    confirmWithdraw: 'Naozaj chcete stiahnuť túto žiadosť?',
    confirmDelete: 'Naozaj chcete vymazať túto žiadosť?',
    confirmPublish: 'Naozaj chcete publikovať túto žiadosť? Bude viditeľná pre všetky národy.',
    confirmStartSelection: 'Naozaj chcete začať výber? Národy budú môcť podávať ponuky.',
    warningStartSelection: 'Začatie výberu sprístupní túto žiadosť všetkým zúčastneným národom. Budú môcť podávať ponuky pre pacientov v tejto žiadosti. Túto akciu nie je možné vrátiť späť.',
    warningMakeOffer: 'Odoslaním tejto ponuky sa zaväzujete, že váš národ poskytne navrhovanú pomoc. Táto akcia upozorní žiadajúci národ a riadenie cvičenia.',
    saveDraft: 'Uložiť koncept',
    saving: 'Ukladá sa...',
    saveAndSubmit: 'Uložiť a odoslať',
    step: 'Krok {{number}}',
    generalInfo: 'Všeobecné informácie',
    patientInfo: 'Informácie o pacientovi',
    logisticsInfo: 'Logistické informácie',
    reviewSubmit: 'Kontrola a odoslanie',
    requestTitle: 'Názov žiadosti',
    requestDescription: 'Popis žiadosti',
    numberOfPatients: 'Počet pacientov',
    typeOfAssistance: 'Typ pomoci',
    medicalTreatment: 'Lekárske ošetrenie',
    transportAssistance: 'Prepravná pomoc',
    both: 'Oboje',
    treatmentOnly: 'Len ošetrenie',
    transportOnly: 'Len preprava',
    validationErrors: 'Prosím opravte nasledujúce chyby:',
    fieldRequired: 'Toto pole je povinné',
    selectExitHub: 'Vyberte výstupný uzol',
    createExitHub: 'Vytvoriť výstupný uzol',
    backToRequests: 'Späť na žiadosti',
    noRequestsFound: 'Žiadne žiadosti nenájdené',
    createFirstRequest: 'Vytvorte svoju prvú žiadosť a začnite',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Ponuky',
    createOffer: 'Vytvoriť ponuku',
    makeOffer: 'Podať ponuku',
    manageOffers: 'Spravovať ponuky',
    offerDetail: 'Detail ponuky',
    offerId: 'ID ponuky',
    offeringNation: 'Ponúkajúci národ',
    offerType: 'Typ ponuky',
    treatment: 'Ošetrenie',
    transport: 'Preprava',
    combined: 'Kombinované',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Ponuka ošetrenia',
    transportOffer: 'Ponuka prepravy',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Vybrať pacientov',
    selectedPatients: 'Vybraní pacienti',
    patientSelection: 'Výber pacientov',
    offerConfiguration: 'Konfigurácia ponuky',
    reviewOffer: 'Skontrolovať ponuku',
    submitOffer: 'Odoslať ponuku',
    submitting: 'Odosiela sa...',
    acceptOffer: 'Prijať ponuku',
    rejectOffer: 'Zamietnuť ponuku',
    withdrawOffer: 'Stiahnuť ponuku',
    noOffers: 'Žiadne ponuky k dispozícii',
    noOffer: 'No Offer',
    offerStatus: 'Stav ponuky',
    offerDate: 'Dátum ponuky',
    transportAsset: 'Prepravný prostriedok',
    departureDate: 'Dátum odchodu',
    arrivalDate: 'Dátum príchodu',
    treatmentFacility: 'Liečebné zariadenie',
    capacity: 'Kapacita',
    availableCapacity: 'Dostupná kapacita',
    totalCapacity: 'Celková kapacita',
    selectAsset: 'Vybrať prostriedok',
    selectFacility: 'Vybrať zariadenie',
    offerNotes: 'Poznámky k ponuke',
    confirmAccept: 'Naozaj chcete prijať túto ponuku?',
    confirmReject: 'Naozaj chcete zamietnuť túto ponuku?',
    extendTransport: 'Predĺžiť prepravu',
    transportExtension: 'Predĺženie prepravy',
    comparisonView: 'Porovnávacie zobrazenie',
    shortlist: 'Užší výber',
    addToShortlist: 'Pridať do užšieho výberu',
    removeFromShortlist: 'Odstrániť z užšieho výberu',
    leaveConfirmTitle: 'Opustiť túto stránku?',
    leaveConfirmMessage: 'Máte neuložené zmeny. Naozaj chcete odísť?',
    stayOnPage: 'Zostať na stránke',
    leavePage: 'Opustiť stránku',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Prepravy',
    missionDetail: 'Detail prepravy',
    missionId: 'ID prepravy',
    missionStatus: 'Stav prepravy',
    createMission: 'Vytvoriť prepravu',
    overview: 'Prehľad',
    patientsTab: 'Pacienti',
    transportsTab: 'Úseky prepravy',
    treatmentTab: 'Ošetrenie',
    reviewTab: 'Kontrola',
    departure: 'Odchod',
    arrival: 'Príchod',
    origin: 'Východisko',
    destination: 'Cieľ',
    stops: 'Zastávky',
    addStop: 'Pridať zastávku',
    removeStop: 'Odstrániť zastávku',
    stopName: 'Názov zastávky',
    stopType: 'Typ zastávky',
    estimatedTime: 'Odhadovaný čas',
    actualTime: 'Skutočný čas',
    asset: 'Prostriedok',
    driver: 'Vodič',
    crew: 'Posádka',
    noMissions: 'Žiadne prepravy nenájdené',
    completeMission: 'Dokončiť prepravu',
    cancelMission: 'Zrušiť prepravu',
    startTransport: 'Začať prepravu',
    missionChain: 'Reťazec prepráv',
    linkedMissions: 'Prepojené prepravy',
    handover: 'Odovzdanie',
    handoverPoint: 'Miesto odovzdania',
    pickupPoint: 'Miesto vyzdvihnutia',
    dropoffPoint: 'Miesto vysadenia',
    searchTransports: 'Hľadať prepravy...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacienti',
    myPatients: 'Moji pacienti',
    patientId: 'ID pacienta',
    firstName: 'Meno',
    lastName: 'Priezvisko',
    dateOfBirth: 'Dátum narodenia',
    age: 'Vek',
    gender: 'Pohlavie',
    male: 'Muž',
    female: 'Žena',
    other: 'Iné',
    nationality: 'Štátna príslušnosť',
    diagnosis: 'Diagnóza',
    condition: 'Stav',
    stable: 'Stabilný',
    critical: 'Kritický',
    serious: 'Vážny',
    treatmentNeeded: 'Potrebné ošetrenie',
    allergies: 'Alergie',
    medications: 'Lieky',
    bloodType: 'Krvná skupina',
    weight: 'Hmotnosť (kg)',
    infectious: 'Infekčný',
    mentalHealth: 'Duševné zdravie',
    mobility: 'Mobilita',
    ambulatory: 'Pohyblivý',
    wheelchair: 'Invalidný vozík',
    stretcher: 'Nosidlá',
    intensive: 'Intenzívna starostlivosť',
    oxygenRequired: 'Vyžadovaný kyslík',
    ventilator: 'Ventilátor',
    medicalEscort: 'Zdravotnícky doprovod',
    noPatients: 'Žiadni pacienti nenájdení',
    patientDetails: 'Údaje o pacientovi',
    medicalHistory: 'Zdravotná anamnéza',
    travelDocuments: 'Cestovné dokumenty',
    passport: 'Cestovný pas',
    pseudonymizedId: 'Pseudonymizované ID',
    sensitiveData: 'Citlivé údaje',
    journey: 'Cesta pacienta',
    assignedTo: 'Priradený k',
    currentLocation: 'Aktuálna poloha',
    importPatients: 'Importovať pacientov',
    exportPatients: 'Exportovať pacientov',
    seated: 'Sediaci',
    lying: 'Ležiaci',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Používatelia',
    createUser: 'Vytvoriť používateľa',
    editUser: 'Upraviť používateľa',
    deleteUser: 'Vymazať používateľa',
    username: 'Používateľské meno',
    displayName: 'Zobrazované meno',
    email: 'E-mail',
    password: 'Heslo',
    role: 'Rola',
    roles: 'Role',
    nation: 'Národ',
    active: 'Aktívny',
    lastLogin: 'Posledné prihlásenie',
    createdAt: 'Vytvorené',
    isNation: 'Národ',
    isEU: 'EÚ',
    isAdmin: 'Administrátor',
    isExcon: 'EXCON',
    isPlanner: 'Plánovač',
    isHub: 'Uzol',
    isReadOnly: 'Len na čítanie',
    noUsers: 'Žiadni používatelia nenájdení',
    confirmDelete: 'Naozaj chcete vymazať tohto používateľa?',
    resetPassword: 'Obnoviť heslo',
    generatePassword: 'Vygenerovať heslo',
    searchUsers: 'Hľadať používateľov...',
    userCreated: 'Používateľ bol úspešne vytvorený',
    userUpdated: 'Používateľ bol úspešne aktualizovaný',
    userDeleted: 'Používateľ bol úspešne vymazaný',
    selectNation: 'Vyberte národ',
    mustChangePassword: 'Pri ďalšom prihlásení musí zmeniť heslo',
    flagImage: 'Obrázok vlajky',
    exportUsers: 'Exportovať používateľov',
    importUsers: 'Importovať používateľov',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Prostriedky',
    createAsset: 'Vytvoriť prostriedok',
    editAsset: 'Upraviť prostriedok',
    deleteAsset: 'Vymazať prostriedok',
    assetName: 'Názov prostriedku',
    assetType: 'Typ prostriedku',
    capacitySeated: 'Kapacita (sediaci)',
    capacityLying: 'Kapacita (ležiaci)',
    capacityIntensive: 'Kapacita (intenzívna)',
    owner: 'Vlastník',
    operator: 'Prevádzkovateľ',
    baseLocation: 'Základná poloha',
    range: 'Dosah',
    speed: 'Rýchlosť',
    noAssets: 'Žiadne prostriedky nenájdené',
    confirmDelete: 'Naozaj chcete vymazať tento prostriedok?',
    searchAssets: 'Hľadať prostriedky...',
    assetCreated: 'Prostriedok bol úspešne vytvorený',
    assetUpdated: 'Prostriedok bol úspešne aktualizovaný',
    assetDeleted: 'Prostriedok bol úspešne vymazaný',
    exportAssets: 'Exportovať prostriedky',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Uzly',
    startPoints: 'Východiskové body',
    createHub: 'Vytvoriť uzol',
    editHub: 'Upraviť uzol',
    deleteHub: 'Vymazať uzol',
    hubName: 'Názov uzla',
    hubType: 'Typ uzla',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Vstupný uzol',
    airport: 'Letisko',
    seaport: 'Prístav',
    railStation: 'Železničná stanica',
    roadPoint: 'Cestný bod',
    ucpmClassification: 'Klasifikácia UCPM',
    icaoCode: 'Kód ICAO',
    iataCode: 'Kód IATA',
    noHubs: 'Žiadne uzly nenájdené',
    confirmDelete: 'Naozaj chcete vymazať tento uzol?',
    searchHubs: 'Hľadať uzly...',
    nationAssignment: 'Priradenie národov',
    assignNations: 'Priradiť národy',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Liečebné zariadenia',
    createFacility: 'Vytvoriť zariadenie',
    editFacility: 'Upraviť zariadenie',
    deleteFacility: 'Vymazať zariadenie',
    facilityName: 'Názov zariadenia',
    facilityType: 'Typ zariadenia',
    hospitalName: 'Názov nemocnice',
    bedCapacity: 'Kapacita lôžok',
    specialties: 'Špecializácie',
    availableBeds: 'Dostupné lôžka',
    totalBeds: 'Celkový počet lôžok',
    contactPerson: 'Kontaktná osoba',
    noFacilities: 'Žiadne liečebné zariadenia nenájdené',
    confirmDelete: 'Naozaj chcete vymazať toto zariadenie?',
    searchFacilities: 'Hľadať zariadenia...',
    hubNationAssignment: 'Priradenie národov k uzlu',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Harmonogramy',
    createSchedule: 'Vytvoriť harmonogram',
    editSchedule: 'Upraviť harmonogram',
    deleteSchedule: 'Vymazať harmonogram',
    scheduleName: 'Názov harmonogramu',
    scheduleType: 'Typ harmonogramu',
    recurring: 'Opakujúci sa',
    oneTime: 'Jednorazový',
    frequency: 'Frekvencia',
    daily: 'Denne',
    weekly: 'Týždenne',
    startDate: 'Dátum začiatku',
    endDate: 'Dátum konca',
    departureTime: 'Čas odchodu',
    arrivalTime: 'Čas príchodu',
    stops: 'Zastávky',
    addStop: 'Pridať zastávku',
    noSchedules: 'Žiadne harmonogramy nenájdené',
    bookings: 'Rezervácie',
    timeline: 'Časová os',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Oznámenia',
    markAllRead: 'Označiť všetky ako prečítané',
    markAsRead: 'Označiť ako prečítané',
    markAsUnread: 'Označiť ako neprečítané',
    noNotifications: 'Žiadne oznámenia',
    viewAll: 'Zobraziť všetky oznámenia',
    settings: 'Nastavenia oznámení',
    emailNotifications: 'E-mailové oznámenia',
    inAppNotifications: 'Oznámenia v aplikácii',
    notifyOn: 'Upozorniť ma na',
    requestCreated: 'Nová žiadosť',
    requestPublished: 'Žiadosť publikovaná',
    requestClosed: 'Žiadosť uzavretá',
    requestCompleted: 'Žiadosť dokončená',
    commentAdded: 'Nový komentár',
    offerReceived: 'Ponuka prijatá',
    offerAccepted: 'Ponuka akceptovaná',
    statusChanged: 'Stav zmenený',
    selectionStarted: 'Výber začal',
    missionCreated: 'Preprava vytvorená',
    missionStatusUpdated: 'Preprava aktualizovaná',
    transportPartnerNamed: 'Prepravný partner',
    transportExtensionReceived: 'Predĺženie prepravy',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Nastavenia',
    general: 'Všeobecné',
    system: 'Systém',
    email: 'E-mail',
    sync: 'Synchronizácia',
    security: 'Bezpečnosť',
    appearance: 'Vzhľad',
    systemName: 'Názov systému',
    systemEmail: 'Systémový e-mail',
    maintenanceMode: 'Režim údržby',
    readOnlyMode: 'Režim len na čítanie',
    emailEnabled: 'E-mail povolený',
    smtpHost: 'SMTP hostiteľ',
    smtpPort: 'SMTP port',
    smtpUser: 'SMTP používateľ',
    smtpPassword: 'SMTP heslo',
    senderEmail: 'E-mail odosielateľa',
    senderName: 'Meno odosielateľa',
    testEmail: 'Odoslať testovací e-mail',
    syncEnabled: 'Synchronizácia povolená',
    syncUrl: 'URL synchronizácie',
    syncApiKey: 'API kľúč synchronizácie',
    settingsSaved: 'Nastavenia boli úspešne uložené',
    helpdesk: 'Technická podpora',
    helpdeskTitle: 'Názov technickej podpory',
    helpdeskEmail: 'E-mail technickej podpory',
    helpdeskPhone: 'Telefón technickej podpory',
    helpdeskInfo: 'Informácie o technickej podpore',
    realLifeSupport: 'Podpora v reálnom živote',
    trainingMode: 'Režim výcviku',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Protokol auditu',
    action: 'Akcia',
    user: 'Používateľ',
    target: 'Cieľ',
    details: 'Podrobnosti',
    timestamp: 'Časová pečiatka',
    ipAddress: 'IP adresa',
    noLogs: 'Žiadne záznamy auditu nenájdené',
    searchLogs: 'Hľadať záznamy...',
    filterByAction: 'Filtrovať podľa akcie',
    filterByUser: 'Filtrovať podľa používateľa',
    exportLogs: 'Exportovať záznamy',
    exportCsv: 'Exportovať CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Riadenie cvičenia',
    currentDay: 'Aktuálny deň',
    exerciseDay: 'Deň cvičenia',
    nextDay: 'Ďalší deň',
    previousDay: 'Predchádzajúci deň',
    resetExercise: 'Obnoviť cvičenie',
    startExercise: 'Začať cvičenie',
    endExercise: 'Ukončiť cvičenie',
    dayReset: 'Obnova dňa',
    confirmReset: 'Naozaj chcete obnoviť deň cvičenia? Tým sa vymažú všetky údaje aktuálneho dňa.',
    resetInProgress: 'Prebieha obnova...',
    maintenanceMode: 'Režim údržby',
    enableMaintenance: 'Povoliť údržbu',
    disableMaintenance: 'Zakázať údržbu',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Synchronizácia údajov',
    syncStatus: 'Stav synchronizácie',
    lastSync: 'Posledná synchronizácia',
    pendingItems: 'Čakajúce položky',
    syncNow: 'Synchronizovať teraz',
    syncing: 'Synchronizuje sa...',
    syncSuccess: 'Synchronizácia bola úspešne dokončená',
    syncFailed: 'Synchronizácia zlyhala',
    outbox: 'Odosielací priečinok',
    inbox: 'Prijímací priečinok',
    configuration: 'Konfigurácia',
    targetUrl: 'Cieľová URL',
    apiKey: 'API kľúč',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Mapa',
    layers: 'Vrstvy',
    requests: 'Žiadosti',
    hubs: 'Uzly',
    facilities: 'Zariadenia',
    routes: 'Trasy',
    showAll: 'Zobraziť všetko',
    hideAll: 'Skryť všetko',
    zoomIn: 'Priblížiť',
    zoomOut: 'Oddialiť',
    resetView: 'Obnoviť zobrazenie',
    satellite: 'Satelitné',
    terrain: 'Terénne',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Mapové dlaždice sú poskytované lokálne',
    tilesOnline: 'Mapové dlaždice sú načítavané z online serverov',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Štatistiky',
    overview: 'Prehľad',
    requestsByStatus: 'Žiadosti podľa stavu',
    requestsByCategory: 'Žiadosti podľa kategórie',
    requestsByNation: 'Žiadosti podľa národa',
    offersByStatus: 'Ponuky podľa stavu',
    patientsByCondition: 'Pacienti podľa stavu',
    transportsByStatus: 'Prepravy podľa stavu',
    timeline: 'Časová os',
    totalRequests: 'Celkový počet žiadostí',
    totalOffers: 'Celkový počet ponúk',
    totalPatients: 'Celkový počet pacientov',
    totalTransports: 'Celkový počet prepráv',
    averageResponseTime: 'Priemerný čas odozvy',
    completionRate: 'Miera dokončenia',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Štatistiky cvičenia',
    overview: 'Prehľad',
    byCategory: 'Podľa kategórie',
    byNation: 'Podľa národa',
    byDay: 'Podľa dňa',
    totalPatientsMoved: 'Celkový počet prevezených pacientov',
    totalRequestsProcessed: 'Celkový počet spracovaných žiadostí',
    averageProcessingTime: 'Priemerný čas spracovania',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Diagram toku',
    sankey: 'Sankey',
    nodeGraph: 'Uzlový graf',
    refresh: 'Obnoviť',
    noData: 'Žiadne údaje o toku nie sú k dispozícii',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'O systéme',
    version: 'Verzia',
    systemInfo: 'Informácie o systéme',
    buildDate: 'Dátum zostavenia',
    environment: 'Prostredie',
    description: 'ARCOS — Pokročilý systém komunikácie žiadostí',
    subtitle: 'Pomoc obetiam a zdravotnícke operácie',
    whatIsArcos: 'Čo je ARCOS? – Vysvetlenie pre účastníkov cvičenia',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'S podporou MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – kde zvedavosť stretáva spoluprácu.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentácia',
    gettingStarted: 'Začíname',
    userGuide: 'Používateľská príručka',
    faq: 'Často kladené otázky',
    troubleshooting: 'Riešenie problémov',
    apiReference: 'API referencia',
    downloadTemplate: 'Stiahnuť šablónu',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Import pacientov',
    uploadFile: 'Nahrať súbor',
    selectFile: 'Vybrať súbor',
    preview: 'Náhľad',
    importNow: 'Importovať teraz',
    importing: 'Importuje sa...',
    importSuccess: '{{count}} pacientov bolo úspešne importovaných',
    importFailed: 'Import zlyhal',
    downloadTemplate: 'Stiahnuť šablónu',
    dragDrop: 'Pretiahnite súbor sem alebo kliknite pre výber',
    supportedFormats: 'Podporované formáty: XLSX, XLS, CSV',
    rowsFound: '{{count}} riadkov nájdených',
    validRows: '{{count}} platných riadkov',
    invalidRows: '{{count}} neplatných riadkov',
    duplicateRows: '{{count}} duplicitných riadkov',
    previewData: 'Náhľad údajov',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Plánovanie prepravy',
    planRoute: 'Plánovať trasu',
    routeBuilder: 'Tvorca trás',
    addWaypoint: 'Pridať bod trasy',
    removeWaypoint: 'Odstrániť bod trasy',
    estimatedDuration: 'Odhadovaná doba trvania',
    distance: 'Vzdialenosť',
    selectVehicle: 'Vybrať vozidlo',
  },

  transportBooking: {
    title: 'Rezervácia prepravy',
    bookTransport: 'Rezervovať prepravu',
    availableSlots: 'Dostupné termíny',
    bookingConfirmed: 'Rezervácia potvrdená',
    cancelBooking: 'Zrušiť rezerváciu',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Plánovanie kapacít',
    totalCapacity: 'Celková kapacita',
    usedCapacity: 'Využitá kapacita',
    availableCapacity: 'Dostupná kapacita',
    utilizationRate: 'Miera využitia',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Šablóny prostriedkov',
    dayTemplates: 'Denné šablóny',
    createTemplate: 'Vytvoriť šablónu',
    editTemplate: 'Upraviť šablónu',
    deleteTemplate: 'Vymazať šablónu',
    templateName: 'Názov šablóny',
    applyTemplate: 'Použiť šablónu',
    noTemplates: 'Žiadne šablóny nenájdené',
    confirmDelete: 'Naozaj chcete vymazať túto šablónu?',
    confirmApply: 'Naozaj chcete použiť túto šablónu? Tým sa prepíšu existujúce údaje.',
    exportTemplates: 'Exportovať šablóny',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Oznamovací panel',
    createAnnouncement: 'Vytvoriť oznámenie',
    editAnnouncement: 'Upraviť oznámenie',
    deleteAnnouncement: 'Vymazať oznámenie',
    message: 'Správa',
    startTime: 'Čas začiatku',
    endTime: 'Čas konca',
    active: 'Aktívne',
    noAnnouncements: 'Žiadne oznámenia',
    confirmDelete: 'Naozaj chcete vymazať toto oznámenie?',
  },

  // ============================================================
  // COMPONENTS — Reťazce opakovaných komponentov
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Hľadať...',
      noResults: 'Žiadne výsledky',
      showing: 'Zobrazuje sa {{from}} až {{to}} z {{total}}',
      rowsPerPage: 'Riadkov na stránku',
      previousPage: 'Predchádzajúca stránka',
      nextPage: 'Ďalšia stránka',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Potvrdiť',
      cancel: 'Zrušiť',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Neuložené zmeny',
      message: 'Máte neuložené zmeny. Naozaj chcete opustiť túto stránku?',
      stay: 'Zostať na stránke',
      leave: 'Opustiť stránku',
    },
    // EmptyState
    emptyState: {
      noData: 'Žiadne dostupné údaje',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Niečo sa pokazilo',
      message: 'Vyskytla sa neočakávaná chyba. Prosím skúste obnoviť stránku.',
      retry: 'Skúsiť znova',
    },
    // ExportButton
    exportButton: {
      export: 'Exportovať',
      exporting: 'Exportuje sa...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Tlačiť',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Koncept',
      review: 'Kontrola',
      published: 'Publikované',
      selection: 'Výber',
      inTransit: 'Na ceste',
      completed: 'Dokončené',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Online inštancia',
      message: 'Režim len na čítanie. Údaje sú synchronizované z primárneho servera.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Zobrazujete sa ako',
      loggedInAs: 'prihlásený ako {{nation}}',
      returnTo: 'Vrátiť sa k {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Hľadať stránky, žiadosti, prepravy...',
      searching: 'Hľadá sa...',
      noResults: 'Žiadne výsledky pre "{{query}}"',
      navigate: 'Navigovať',
      select: 'Vybrať',
      close: 'Zavrieť',
      pages: {
        dashboard: 'Hlavný panel',
        requests: 'Žiadosti',
        transports: 'Prepravy',
        map: 'Mapa',
        myPatients: 'Moji pacienti',
        flowDiagram: 'Diagram toku',
        statistics: 'Štatistiky',
        assets: 'Prostriedky',
        startPoints: 'Východiskové body / Uzly',
        treatmentFacilities: 'Liečebné zariadenia',
        users: 'Používatelia',
        settings: 'Nastavenia',
        auditLogs: 'Protokol auditu',
        exerciseControl: 'Riadenie cvičenia',
        dataSync: 'Synchronizácia údajov',
        patientImport: 'Import pacientov',
        notifications: 'Oznámenia',
        documentation: 'Dokumentácia',
      },
      actions: {
        importPatientsJson: 'Importovať Pacientov (JSON)',
        importPatientsExcel: 'Importovať Pacientov (Excel)',
        importUsers: 'Importovať Používateľov (Excel)',
        importAssetTemplates: 'Importovať Šablóny prostriedkov (Excel)',
        importDayTemplates: 'Importovať Záznamy dennej šablóny (Excel)',
        exportRequests: 'Exportovať Žiadostí (Excel)',
        exportPatients: 'Exportovať Pacientov (Excel)',
        exportUsers: 'Exportovať Používateľov (Excel)',
        exportCredentials: 'Exportovať Prihlasovacie údaje (PDF)',
        exportAuditExcel: 'Exportovať Protokol auditu (Excel)',
        exportAuditPdf: 'Exportovať Protokol auditu (PDF)',
        pagePatientImport: 'Stránka importu pacientov',
        pageRequestDetail: 'Stránka detailu žiadosti',
        pageUsers: 'Stránka správy používateľov',
        pageAssetTemplates: 'Stránka šablón prostriedkov',
        pageDayTemplates: 'Stránka denných šablón',
        pageRequests: 'Stránka zoznamu žiadostí',
        pageAuditLogs: 'Stránka protokolu auditu',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Relácia vyprší',
      message: 'Vaša relácia vyprší o <strong>{{time}}</strong>. Prosím uložte svoju prácu a znova sa prihláste.',
      dismiss: 'Zavrieť',
      logoutNow: 'Odhlásiť sa teraz',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Vyberte 4 časové pásma',
      configure: 'Konfigurovať časové pásma',
      reset: 'Obnoviť',
      apply: 'Použiť',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Vybrať polohu',
      latitude: 'Zemepisná šírka',
      longitude: 'Zemepisná dĺžka',
      clickToSelect: 'Kliknite na mapu pre výber polohy',
    },
    // Modal
    modal: {
      close: 'Zavrieť',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Domov',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Údržba systému',
    message: 'Systém sa resetuje pre ďalší deň cvičenia. Prosím počkajte, kým sa proces dokončí.',
    autoRefresh: 'Táto stránka sa automaticky obnoví, keď bude systém opäť dostupný.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Aspoň 10 znakov',
    uppercase: '1 veľké písmeno',
    lowercase: '1 malé písmeno',
    digit: '1 číslica',
    special: '1 špeciálny znak',
  },
};

export default sk;
